import { create } from "zustand";

export type ChangelogMode = "view" | "edit";

interface ChangelogStore {
	/** Whether the changelog modal is open. */
	open: boolean;
	/** Read-only viewer vs the passkey-gated editor. */
	mode: ChangelogMode;
	/** Marketing version selected in the left rail. */
	selectedVersion: string | null;
	/** The validated editor passkey, kept in memory for saving. */
	passkey: string | null;
	openViewer: () => void;
	openEditor: (passkey: string) => void;
	close: () => void;
	setSelectedVersion: (version: string | null) => void;
}

const useChangelogStore = create<ChangelogStore>((set) => ({
	open: false,
	mode: "view",
	selectedVersion: null,
	passkey: null,
	openViewer: () => set({ open: true, mode: "view" }),
	openEditor: (passkey) => set({ open: true, mode: "edit", passkey }),
	close: () => set({ open: false }),
	setSelectedVersion: (selectedVersion) => set({ selectedVersion }),
}));

export default useChangelogStore;
